import { render, staticRenderFns } from "./organizationList.vue?vue&type=template&id=2bf86049&scoped=true&"
import script from "./organizationList.js?vue&type=script&lang=js&"
export * from "./organizationList.js?vue&type=script&lang=js&"
import style0 from "./organizationList.vue?vue&type=style&index=0&id=2bf86049&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf86049",
  null
  
)

export default component.exports